var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquidxx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3716 13.907L32.9936 38.8005H37.2105L18.5884 13.907H14.3716Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7543 0.882812C11.687 0.882812 0.283447 12.2864 0.283447 26.3537C0.283447 40.421 11.687 51.8246 25.7543 51.8246C39.8216 51.8246 51.2252 40.421 51.2252 26.3537C51.2252 12.2864 39.8216 0.882812 25.7543 0.882812ZM31.9987 40.7895L23.5208 29.4538L13.028 40.7895H10.3309L22.3158 27.8423L10.4061 11.9179H19.5853L27.393 22.3576L37.0561 11.9179H39.7531L28.598 23.9696L41.1778 40.7895H31.9987Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.5662,
    height: 51.5662,
    fill: "white",
    transform: "translate(0 0.599365)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquidxx);
export default __webpack_public_path__ + "static/media/squidxx.4fd0a6efa67b7694d121a305e83454c2.svg";
export { ForwardRef as ReactComponent };